export function toSnakeCase(Text: string) {
  return Text.toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '');
}

// remove all non-word characters
export function toCamelCase(Text: string) {
  const str = Text.replace(/[^\w]+/g, ' ');

  return str.replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase();
  });
}
